import request from '@/utils/request'


// 查询用户信息列表
export function listUser(query) {
  return request({
    url: '/biz/user/list',
    method: 'get',
    params: query
  })
}



// 重置密码用户信息
export function resetPassword(data) {
  return request({
    url: '/biz/user/resetPassword',
    method: 'post',
    data: data
  })
}

// 查询用户信息分页
export function pageUser(query) {
  return request({
    url: '/biz/user/page',
    method: 'get',
    params: query
  })
}

// 查询用户信息详细
export function getUser(data) {
  return request({
    url: '/biz/user/detail',
    method: 'get',
    params: data
  })
}

// 新增用户信息
export function addUser(data) {
  return request({
    url: '/biz/user/add',
    method: 'post',
    data: data
  })
}

// 修改用户信息
export function updateUser(data) {
  return request({
    url: '/biz/user/edit',
    method: 'post',
    data: data
  })
}

// 设置用户分销佣金开关
export function updateReferralEnabled(data) {
  return request({
    url: '/biz/user/referral-enabled',
    method: 'post',
    data: data
  })
}

// 设置用户拉黑状态
export function updateBlacklist(data) {
  return request({
    url: '/biz/user/blacklist',
    method: 'post',
    data: data
  })
}

// 修改用户金额（历史交易总额/钱包余额/已提现总额）
export function updateUserAmounts(data) {
  return request({
    url: '/biz/user/update-amounts',
    method: 'post',
    data: data
  })
}

// 用户金额修改记录分页
export function pageUserAmountModifyLogs(query) {
  return request({
    url: '/biz/user/amount-modify-logs',
    method: 'get',
    params: query
  })
}

//获取统计
export function homePageStatistics() {
  return request({
    url: '/biz/user/homePageStatistics',
    method: 'get'
  })
}

// 查询用户绑定的银行卡
export function listUserBankCards(userId) {
  return request({
    url: '/biz/user/bank-cards',
    method: 'get',
    params: { id: userId }
  })
}

// 删除用户信息
export function delUser(data) {
  return request({
    url: '/biz/user/delete',
    method: 'post',
    data: data
  })
}
